import styled from "styled-components";

export const GalleryContainer = styled.div`
  width: 100%;
  border: 1px solid lightgrey;
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
`;

export const GalleryItem = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  flex: 0 1 48%;
  margin: 1%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  @media screen and (min-width: 992px) {
    flex: 0 1 23%;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0px 0px 25px 5px rgba(0, 0, 0, 0.35);
    }
  }
`;
